/**
 * cn() — utility для условного объединения Tailwind-классов.
 * Используется во всех компонентах: <div className={cn('base', isActive && 'bg-primary-500')}>
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Удобный format для денег. */
export function fmtMoney(n: number, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(n);
}

/** Сокращение больших чисел: 1200 → 1.2k */
export function fmtCompact(n: number) {
  return new Intl.NumberFormat('en-US', { notation: 'compact' }).format(n);
}
